import React, { useState } from "react"
import classnames from "classnames"
import DatePicker from "react-datepicker"
import { Controller, FormProvider } from "react-hook-form"
import { useOrdersFilter } from "@usher/pe-client-front-end-lib"
import { IconChevronDown /*, IconClose*/, IconSearch } from "@/Images/Icons"
import FormSelect from "@/Components/FormSelect"
import Button from "@/Components/Button"
import "./index.sass"
import "react-datepicker/dist/react-datepicker.min.css"

function FilterSelect({ formMethods, options, name, label }) {
  return (
    <div className="TransactionsFilter__Select">
      <div className="TransactionsFilter__Label">{label}:</div>
      <Controller
        control={formMethods.control}
        name={name}
        render={({ onChange, value, name }) => (
          <FormSelect
            type="Simple"
            options={options[name]}
            name={name}
            value={value}
            theme="Dark"
            size="Small"
            handleChange={onChange}
          />
        )}
      />
    </div>
  )
}

export const TransactionsFilter = ({
  onFilter,
  type = "Buy",
  withoutExchangeTo = false,
  compact = false,
}) => {
  const { options, /*onReset, */ onSubmit, formMethods } = useOrdersFilter({
    onFilter,
    type,
    compact,
  })
  const [filterOpen, setFilterOpen] = useState(false)
  const watchPeriod = formMethods.watch("period")

  return (
    <FormProvider {...formMethods}>
      <form
        onSubmit={formMethods.handleSubmit(onSubmit)}
        className={classnames("TransactionsFilter", {
          "TransactionsFilter--Open": filterOpen,
        })}
      >
        <div className="TransactionFilter__Head" onClick={() => setFilterOpen(!filterOpen)}>
          Search <IconChevronDown />
        </div>
        <div className="TransactionsFilter__Inner">
          <div className="TransactionsFilter__Items">
            <FilterSelect
              formMethods={formMethods}
              options={options}
              name="period"
              label="Period"
            />
            {watchPeriod.value !== "0" && (
              <div className="TransactionsFilter__Select">
                <Controller
                  control={formMethods.control}
                  name="date"
                  render={({ onChange, value, name }) => (
                    <DatePicker
                      name={name}
                      selected={value[0]}
                      startDate={value[0]}
                      endDate={value[1]}
                      onChange={onChange}
                      maxDate={new Date()}
                      className="Form-Input Form-Input--Dark"
                      isClearable
                      selectsRange
                    />
                  )}
                />
              </div>
            )}
            {withoutExchangeTo !== true && (
              <>
                <FilterSelect
                  formMethods={formMethods}
                  options={options}
                  name="fiat"
                  label="Exchange from"
                />
                <FilterSelect
                  formMethods={formMethods}
                  options={options}
                  name="crypto"
                  label="Exchange to"
                />
              </>
            )}
            <FilterSelect
              formMethods={formMethods}
              options={options}
              name="status"
              label="Status"
            />
          </div>
          <Button
            icon={<IconSearch />}
            color="Blue"
            size="Medium"
            type="submit"
            style={{ marginLeft: "auto" }}
          >
            Search
          </Button>
          {/*<Button icon={<IconClose/>} color="Dark" size="Medium" onClick={onReset}
                  className="TransactionsFilter__Reset"/>*/}
        </div>
      </form>
    </FormProvider>
  )
}
